import { useUser } from './useUser';

export function useFeatureFlags() {
  const { data: user } = useUser();

  return user?.featureFlags || {};
}

